module.exports = __webpack_public_path__ + "img/Extra.783d6520.png";